
import axiosInstance from "components/utils/axiosInstance";

export const recordAppDownload = async (data) => {
  const response = await axiosInstance.post(
    `/AppDownloads`,
    {
      platform: "pwa",
      appVersion: data?.appVersion ?? null,
      source: data?.source ?? "direct",
    }
  );

  return response.data;
};